import { type TranslationMessages } from 'react-admin'
import jaMessages from '@bicstone/ra-language-japanese'

export const ja: TranslationMessages = {
  ...jaMessages,
  resources: {
    users: {
      edit: {
        title: '対象の利用者/利用拠点の検索',
        fields: {
          name: '氏名',
          address: '住所',
          place: '物件名'
        },
        buttons: {
          search: '検索'
        }
      },
      show: {
        title: '解約予定日の入力',
        fields: {
          stop: '解約予定日',
          phone: '携帯電話番号',
          family: {
            name: '緊急連絡先氏名',
            nameKana: '緊急連絡先氏名カナ(全角)',
            sms: '緊急連絡先SMS送信先電話番号',
            phone: '緊急連絡先電話番号',
            postalCode: '緊急連絡先郵便番号'
          },
          schedules: '不在予定'
        },
        buttons: {
          submit: '設定'
        },
        list: {
          title: '対象の利用者/利用拠点を選択してください'
        },
        record: {
          title: '対象の利用者/利用拠点'
        },
        notifications: {
          notFound: '該当する利用者/利用拠点が見つかりません。'
        }
      },
      fields: {
        name: '氏名/拠点名',
        address: '住所',
        place: '物件名',
        placeNumber: '部屋番号',
        phone: '電話番号',
        start: '利用開始日',
        stop: '解約予定日',
        end: '解約日',
        status: '利用状況',
        product: '担当管理会社',
        'families.0': {
          name: '緊急連絡先氏名',
          nameKana: '緊急連絡先氏名カナ',
          sms: '緊急連絡先SMS送信先電話番号',
          phone: '緊急連絡先電話番号',
          postalCode: '緊急連絡先郵便番号'
        },
        contractor: {
          name: '電気契約者氏名',
          address: '電気契約者住所'
        }
      },
      solarFields: {
        name: '氏名/拠点名',
        address: '住所',
        phone: '電話番号',
        start: '利用開始日',
        stop: '解約予定日',
        end: '解約日',
        status: 'ご利用状況',
        product: 'ご担当管理会社',
        contractor: {
          name: '電気契約名義',
          address: '電気契約名義住所'
        },
        classification: '受給区分（受電／供給）',
        spin: '受電/供給地点特定番号'
      }
    },
    dashboard: {
      title: 'テラシテRサービス管理ページ',
      menu: {
        edit: '利用者/利用拠点情報の\n変更',
        download: '利用者/利用拠点\n一覧の取得',
        upload: '利用者/利用拠点情報の\n変更の一括登録',
        editContact: '通知先メールアドレスの\n追加・変更',
        summary: '申込未受領者一括取得'
      },
      admin: {
        download: 'アカウント一覧の取得',
        upload: 'アカウントの登録/削除'
      },
      notification: {
        cannotUse: 'ご利用できません'
      }
    },
    download: {
      dialog: {
        content:
          '利用者/利用拠点一覧を取得するURLをメールでお送りします。\nなお、URLの有効期限は1日となっています。\n\n有効期限を過ぎた場合はこちらのページから再度、手続きを行ってください。',
        buttons: {
          cancel: 'キャンセル',
          confirm: 'ダウンロード'
        }
      }
    },
    upload: {
      dialog: {
        content:
          '取得した利用者/利用拠点一覧のファイルに変更内容を入力したファイルのアップロードを行ってください。\n\nなお、解約予定日、電話番号、緊急連絡先の情報以外の項目を変更されても反映されませんのでご注意ください。',
        buttons: {
          cancel: 'キャンセル',
          confirm: 'アップロード'
        }
      },
      notification: {
        uploading: 'アップロード中...',
        'cannot upload': 'アップロードできません。'
      }
    },
    partnerSelect: {
      dialog: {
        buttons: {
          prev: '前へ',
          next: '次へ',
          cancel: 'キャンセル',
          confirm: '設定'
        },
        title: '事業者の選択'
      }
    },
    cognito: {
      download: {
        dialog: {
          content:
            'アカウント一覧を取得するURLをメールでお送りします。\nなお、URLの有効期限は1日となっています。\n\n有効期限を過ぎた場合はこちらのページから再度、手続きを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        }
      },
      upload: {
        dialog: {
          content:
            '必ず取得したアカウント一覧のファイルを編集したファイルのアップロードを行ってください。\n\nなお、一覧から削除するとアカウントの削除が行われますのでご注意ください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'アップロード'
          }
        },
        notification: {
          uploading: 'アップロード中...',
          'cannot upload': 'アップロードできません。'
        }
      },
      execute: {
        confirm: 'アカウントの削除を実行するには、ボタンを押してください。',
        buttons: {
          execute: '実行'
        },
        dialog: {
          title: 'アカウントの削除の実行',
          content: 'アカウントの削除を実行します。',
          cancel: 'キャンセル',
          confirm: '実行'
        }
      }
    },
    summary: {
      download: {
        dialog: {
          content:
            '見守りサービスの申込書が届いていない/電子申込がお済でない入居者様の一覧を取得することが可能です。以下「ダウンロード」 を押下すると、ダウンロード用のURLをメールでお送りします。\nなお、URLの有効期限は1日となっています。\n有効期限を過ぎた場合はこちらのページから再度、手続きを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        }
      }
    },
    announce: {
      title: 'サービスからのお知らせ'
    },
    contactEdit: {
      title: '通知先メールアドレスの編集',
      buttons: {
        save: '登録'
      }
    },
    orderR: {
      name: 'テラシテR申込フォーム',
      title: 'お申し込みフォーム',
      fields: {
        name: '氏名',
        nameKana: '氏名(カナ)',
        postalCode: '郵便番号(ハイフンなし)',
        address: '住所',
        place: '物件名',
        placeNumber: '部屋番号',
        sms: 'SMS送信先電話番号(ハイフンなし)',
        phone: '音声連絡先電話番号(ハイフンなし)',
        customerNumber: '電気契約のお客様番号(13桁数字)',
        email: 'メールアドレス',
        familyName: '緊急連絡先氏名',
        familyNameKana: '緊急連絡先氏名カナ',
        familyPhone: '緊急連絡先電話番号(ハイフンなし)',
        familyPostalCode: '緊急連絡先郵便番号',
        identification: '公的証明書番号',
        bankCode: '金融機関コード',
        branchCode: '支店コード',
        accountType: '預金区分',
        accountNumber: '口座番号',
        accountName: '口座名義カナ',
        accountNameKanji: '口座名義(漢字)',
        savings: '普通',
        current: '当座',
        entry: '入居予定日'
      },
      addressInput: '住所自動入力',
      submit: {
        l1: '登録'
      },
      userTitle: 'ご契約者',
      familyTitle: '緊急連絡先',
      bankAccount: {
        title: '口座振替登録',
        dialog: {
          content: '金融機関サイトへ移動します',
          ok: '確認'
        },
        submitButton: '登録'
      }
    }
  },
  scheduleInput: {
    clear: 'クリア',
    cancel: 'キャンセル',
    set: '設定'
  },
  ra: {
    ...jaMessages.ra,
    auth: {
      ...jaMessages.ra.auth,
      require_new_password: '新しいパスワードを設定してください',
      username: 'アカウント(メールアドレス)',
      password: 'パスワード',
      confirm_password: 'パスワード(確認用)',
      sign_in: 'ログイン',
      sign_in_error: 'ログインエラー',
      auth_check_error: 'メールアドレスまたはパスワードが違います',
      forgot_password: 'パスワードをお忘れ/ご変更の方はこちらから',
      exec_forgot_password: '新しいパスワードの設定',
      require_verification_code: 'メールに届いた確認コードを入力してください',
      verification_code: '確認コード',
      send_verification_code: '確認コードを送信'
    },
    validation: {
      ...jaMessages.ra.validation,
      do_not_match: 'パスワードが一致しません'
    }
  },
  'too small': '文字数が不足しています',
  'too large': '文字数が多すぎます',
  'Expected string, received null': '入力必須です',
  'cannot download summary': '取得できません'
}
